// extracted by mini-css-extract-plugin
module.exports = {"title":"InvoiceHow_title__U_6Us","list":"InvoiceHow_list__SK9RN","list__item":"InvoiceHow_list__item__l2I9K"};